export enum DistributionContactsListSourceType {
	DistributionList = 1,
	ResetResendReopen = 2,
	DistributionContactsModal = 3,
}
